import { render, staticRenderFns } from "./ourApp_m.vue?vue&type=template&id=23148c34&scoped=true&"
import script from "./ourApp_m.vue?vue&type=script&lang=js&"
export * from "./ourApp_m.vue?vue&type=script&lang=js&"
import style0 from "./ourApp_m.vue?vue&type=style&index=0&id=23148c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23148c34",
  null
  
)

export default component.exports